import { API } from '../../../network/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const fetchFarmer = async (farmerId: string, signal: AbortSignal) => {
  try {
    const res = await API.get(`farmers/farmers/${farmerId}`, {
      signal,
    });
    return res.data;
  } catch (err) {
    if (err instanceof Error) throw err;
    throw new Error('Something went wrong');
  }
};

const SIGNED_CONTRACT_TAG = 'FARMER_CONTRACT_SIGNED';
const FARMER_WITH_CONTRACT = 'FARMER_CONTRACT_PROFILE';

const useFarmerQuery = (farmerId?: string) => {
  const queryClient = useQueryClient();
  const res = useQuery({
    queryKey: ['farmer', { farmerId }],
    queryFn: ({ signal }) => fetchFarmer(farmerId ?? '', signal),
    select: (data) => ({
      ...data,
      signedContractImage: data?.contracts?.find(
        (item: Record<string, unknown>) => item?.tag === SIGNED_CONTRACT_TAG,
      ),
      farmerWithContractImage: data?.contracts?.find(
        (item: Record<string, unknown>) => item?.tag === FARMER_WITH_CONTRACT,
      ),
      nationalIdImages:
        data?.nationalIds
          ?.map((image: { url: string }) => image?.url)
          ?.filter(Boolean) || [],
    }),
    enabled: !!farmerId,
    staleTime: 1000 * 10,
  });

  const prefetch = (id: string) => {
    return queryClient.prefetchQuery({
      queryKey: ['farmer', { farmerId: id }],
      queryFn: ({ signal }) => fetchFarmer(id, signal),
      staleTime: 1000 * 10,
    });
  };

  return {
    ...res,
    prefetch,
  };
};

export default useFarmerQuery;
